/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { UsersControllerService } from './services/users-controller.service';
import { TeamsControllerService } from './services/teams-controller.service';
import { ActivitiesControllerService } from './services/activities-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    UsersControllerService,
    TeamsControllerService,
    ActivitiesControllerService,
    ApiConfiguration
  ],
})
export class CustomersUsersModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersUsersModule> {
    return {
      ngModule: CustomersUsersModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersUsersModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersUsersModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
